import { combineReducers } from 'redux'

import componentDataReducer from './componentDataSlice';

const rootReducer = combineReducers({
  componentData: componentDataReducer,
})

export default rootReducer
